class PortsValidationService {
  validatePort(port: string) {
    if (!port) {
      return {
        type: 'empty',
        start: 0,
        end: 0,
      };
    }
    const regexCheckPort = /^(([0-9]{1,5})|([0-9]{1,5}-[0-9]{1,5}))$/.test(port);
    if (!regexCheckPort) {
      return {
        type: 'regexp',
        start: 0,
        end: 0,
      };
    }
    let portStart = parseInt(port, 10);
    let portEnd = parseInt(port, 10);
    if (port.indexOf('-') !== -1) {
      const data = port.split('-');
      portStart = parseInt(data[0], 10);
      portEnd = parseInt(data[1], 10);
      if (portStart > portEnd) {
        return {
          type: 'range',
          start: portStart,
          end: portEnd,
        };
      }
    }
    if (portStart > 65535 || portStart < 1 || portEnd > 65535 || portEnd < 1) {
      return {
        type: 'regexp',
        start: portStart,
        end: portEnd,
      };
    }
    return {
      type: 'valid',
      start: portStart,
      end: portEnd,
    };
  }

  validatePorts(
    sourcePort: string,
    destPort: string,
    isAdvanceRangeCheck: boolean = true
  ): { isValid: boolean; sourcePort: string; destPort: string } {
    const sourcePortData = this.validatePort(sourcePort);
    const destPortData = this.validatePort(destPort);

    if (sourcePortData.type !== 'valid' || destPortData.type !== 'valid') {
      return {
        isValid: false,
        sourcePort: sourcePortData.type,
        destPort: destPortData.type,
      };
    }

    if (isAdvanceRangeCheck) {
      let sourcePortsCount = sourcePortData.end - sourcePortData.start + 1;
      let destPortsCount = destPortData.end - destPortData.start + 1;
      let sourcePortError = sourcePortsCount < 1;
      let destPortError = destPortsCount < 1;
      if (sourcePortsCount < destPortsCount) {
        sourcePortError = true;
        destPortError = true;
      } else {
        if (destPortsCount !== 1 && sourcePortsCount !== destPortsCount) {
          sourcePortError = true;
          destPortError = true;
        }
      }
      if (sourcePortError || destPortError) {
        return {
          isValid: false,
          sourcePort: sourcePortError ? 'range' : 'valid',
          destPort: destPortError ? 'range' : 'valid',
        };
      }
    }
    return {
      isValid: true,
      sourcePort: 'valid',
      destPort: 'valid',
    };
  }
}

export const portsValidationService = new PortsValidationService();
